import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { createUser, NewUserData } from '../../../services/userService';
import { UserRole, UserStatus } from '../../../types/user'; // استيراد UserStatus
import formStyles from '../trainees/TraineeForm.module.css';

// تم تحديث النوع ليشمل confirmPassword
type FormInputs = NewUserData & { confirmPassword: string };

const AddUserPage: React.FC = () => {
  const navigate = useNavigate();
  const { 
    register, 
    handleSubmit, 
    watch,
    formState: { errors, isSubmitting } 
  } = useForm<FormInputs>({
    defaultValues: {
      role: UserRole.SUBSCRIBER,
      status: UserStatus.ACTIVE, // القيمة الافتراضية للحالة
    }
  });

  const password = watch('password');

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    const { confirmPassword, ...submissionData } = data;
    const promise = createUser(submissionData);

    toast.promise(promise, {
      loading: 'جاري إنشاء المستخدم...',
      success: () => {
        navigate('/admin/users/list');
        return 'تم إنشاء المستخدم بنجاح!';
      },
      error: (err) => err.response?.data?.message || 'فشل في إنشاء المستخدم.',
    });
  };

  return (
    <div className={formStyles.pageContainer}>
      <div className={formStyles.formContainer}>
        <h2 className={formStyles.title}>إضافة مستخدم جديد</h2>
        <form onSubmit={handleSubmit(onSubmit)} className={formStyles.form}>
          
          <div className={formStyles.formField}>
            <label htmlFor="email" className={formStyles.label}>البريد الإلكتروني</label>
            <input id="email" type="email" {...register('email', { required: 'البريد الإلكتروني مطلوب', pattern: { value: /^\S+@\S+$/i, message: 'صيغة البريد الإلكتروني غير صالحة' } })} className={formStyles.input} />
            {errors.email && <p className={formStyles.error}>{errors.email.message}</p>}
          </div>

          {/* تم استبدال الاسم بالهاتف */}
          <div className={formStyles.formField}>
            <label htmlFor="phone" className={formStyles.label}>رقم الهاتف</label>
            <input id="phone" type="tel" {...register('phone', { required: 'رقم الهاتف مطلوب' })} className={formStyles.input} />
            {errors.phone && <p className={formStyles.error}>{errors.phone.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="password" className={formStyles.label}>كلمة المرور</label>
            <input id="password" type="password" {...register('password', { required: 'كلمة المرور مطلوبة', minLength: { value: 8, message: 'يجب أن تكون 8 أحرف على الأقل' } })} className={formStyles.input} />
            {errors.password && <p className={formStyles.error}>{errors.password.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="confirmPassword" className={formStyles.label}>تأكيد كلمة المرور</label>
            <input id="confirmPassword" type="password" {...register('confirmPassword', { required: 'التأكيد مطلوب', validate: value => value === password || 'كلمتا المرور غير متطابقتين' })} className={formStyles.input} />
            {errors.confirmPassword && <p className={formStyles.error}>{errors.confirmPassword.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="role" className={formStyles.label}>دور المستخدم</label>
            <select id="role" {...register('role', { required: 'الدور مطلوب' })} className={formStyles.input}>
              {Object.values(UserRole).map(role => (
                <option key={role} value={role}>{role}</option>
              ))}
            </select>
          </div>

          {/* تم إضافة حقل الحالة */}
          <div className={formStyles.formField}>
            <label htmlFor="status" className={formStyles.label}>حالة الحساب</label>
            <select id="status" {...register('status', { required: 'الحالة مطلوبة' })} className={formStyles.input}>
              {Object.values(UserStatus).map(status => (
                <option key={status} value={status}>{status}</option>
              ))}
            </select>
          </div>

          <div className={`${formStyles.buttonContainer} ${formStyles.fullWidth}`}>
            <Link to="/admin/users/list" className={formStyles.cancelButton}>إلغاء</Link>
            <button type="submit" disabled={isSubmitting} className={formStyles.submitButton}>
              {isSubmitting ? 'جاري الإنشاء...' : 'إنشاء المستخدم'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserPage;
